export const ANALYTICS_EVENTS = {
  ACCOUNT_DELETION_CANCELLED: 'account_deletion_cancelled',
  ACCOUNT_DELETION_CONFIRMED: 'account_deletion_confirmed',
  ACCOUNT_DELETION_INITIATED: 'account_deletion_initiated',
  ACTION_ITEM_ADDED: 'action_item_added',
  ACTION_ITEM_DELETED: 'action_item_deleted',
  ACTION_ITEM_TOGGLED: 'action_item_toggled',
  ACTION_ITEMS_EXTRACT_CLICKED: 'action_items_extract_clicked',
  ACTION_ITEMS_REGENERATE_CLICKED: 'action_items_regenerate_clicked',
  ACTION_ITEMS_SUGGEST_CLICKED: 'action_items_suggest_clicked',
  ANALYZE_CONTEXT_CLICKED: 'analyze_context_clicked',
  ANALYZE_EMAILS_BUTTON_CLICKED: 'analyze_emails_button_clicked',
  ASK_AI_QUESTION_SENT: 'ask_ai_question_sent',
  AUTO_ARCHIVE_INBOX_NOTICE_DISMISSED: 'auto_archive_inbox_notice_dismissed',
  AUTO_ARCHIVE_INBOX_NOTICE_REVIEW_CLICKED: 'auto_archive_inbox_notice_review_clicked',
  AUTO_ARCHIVE_INBOX_NOTICE_SHOWN: 'auto_archive_inbox_notice_shown',
  AUTO_ARCHIVE_PROPOSAL_APPROVED: 'auto_archive_proposal_approved',
  AUTO_ARCHIVE_PROPOSAL_DISMISSED: 'auto_archive_proposal_dismissed',
  AUTO_ARCHIVE_SCAN_REQUESTED: 'auto_archive_scan_requested',
  BLOCKED_KEYWORD_ADDED: 'blocked_keyword_added',
  BULK_ARCHIVE_CLICKED: 'bulk_archive_clicked',
  BULK_FOLLOWUPS_GENERATE_CLICKED: 'bulk_followups_generate_clicked',
  BULK_FOLLOWUPS_GENERATE_RETRY_CLICKED: 'bulk_followups_generate_retry_clicked',
  BULK_FOLLOWUPS_SEND_CANCELLED: 'bulk_followups_send_cancelled',
  BULK_FOLLOWUPS_SEND_CLICKED: 'bulk_followups_send_clicked',
  BULK_FOLLOWUPS_SEND_CONFIRMED: 'bulk_followups_send_confirmed',
  BULK_MARK_AS_READ_CLICKED: 'bulk_mark_as_read_clicked',
  BULK_MARK_AS_UNREAD_CLICKED: 'bulk_mark_as_unread_clicked',
  BULK_SELECTION_CLEARED: 'bulk_selection_cleared',
  BULK_SNOOZE_CANCELLED: 'bulk_snooze_cancelled',
  BULK_SNOOZE_CLICKED: 'bulk_snooze_clicked',
  BULK_SNOOZE_CONFIRMED: 'bulk_snooze_confirmed',
  BULK_STAR_SET: 'bulk_star_set',
  CALENDAR_INVITATION_RESPONDED: 'calendar_invitation_responded',
  COMPOSE_BUTTON_CLICKED: 'compose_button_clicked',
  COMPOSE_CONTACT_SELECTED: 'compose_contact_selected',
  COMPOSE_CONTACTS_SYNCED: 'compose_contacts_synced',
  COMPOSE_SENT: 'compose_sent',
  COMPOSE_VIEWED: 'compose_viewed',
  CONTACTS_SYNC_CLICKED: 'contacts_sync_clicked',
  CONTACTS_VIEWED: 'contacts_viewed',
  CRM_UPGRADE_PROMPT_VIEWED: 'crm_upgrade_prompt_viewed',
  CRM_UPGRADE_VIEW_PLANS_CLICKED: 'crm_upgrade_view_plans_clicked',
  CONTEXT_DELETED: 'context_deleted',
  CONTEXT_EDIT_CLICKED: 'context_edit_clicked',
  CONTEXT_ADD_MATCHING_RULE_CLICKED: 'context_add_matching_rule_clicked',
  CONTEXT_ADD_WORKFLOW_CLICKED: 'context_add_workflow_clicked',
  DATA_EXPORT_COMPLETED: 'data_export_completed',
  DATA_EXPORT_FAILED: 'data_export_failed',
  DATA_EXPORT_INITIATED: 'data_export_initiated',
  DATA_IMPORT_COMPLETED: 'data_import_completed',
  DATA_IMPORT_FAILED: 'data_import_failed',
  DATA_IMPORT_INITIATED: 'data_import_initiated',
  EMAIL_ARCHIVE_CLICKED: 'email_archive_clicked',
  EMAIL_BLOCK_SENDER_CLICKED: 'email_block_sender_clicked',
  EMAIL_CLICKED: 'email_clicked',
  EMAIL_DELETE_CLICKED: 'email_delete_clicked',
  EMAIL_DETAIL_VIEWED: 'email_detail_viewed',
  EMAIL_SNOOZE_CANCELLED: 'email_snooze_cancelled',
  EMAIL_SNOOZE_CLICKED: 'email_snooze_clicked',
  EMAIL_SNOOZE_CONFIRMED: 'email_snooze_confirmed',
  EMAIL_STAR_COUNT_CHANGED: 'email_star_count_changed',
  EMAIL_STAR_SET: 'email_star_set',
  EMAIL_UNSUBSCRIBE_CLICKED: 'email_unsubscribe_clicked',
  GITHUB_CONNECT_CLICKED: 'github_connect_clicked',
  GITHUB_DISCONNECT_CLICKED: 'github_disconnect_clicked',
  GOOGLE_LOGIN_INITIATED: 'google_login_initiated',
  ZOHO_LOGIN_INITIATED: 'zoho_login_initiated',
  HELP_LINK_CLICKED: 'help_link_clicked',
  INBOX_MODE_CHANGED: 'inbox_mode_changed',
  INBOX_VIEWED: 'inbox_viewed',
  KEYWORD_UNBLOCKED: 'keyword_unblocked',
  OPENAI_API_KEY_REMOVED: 'openai_api_key_removed',
  ANTHROPIC_API_KEY_SAVED: 'anthropic_api_key_saved',
  ANTHROPIC_API_KEY_REMOVED: 'anthropic_api_key_removed',
  OPENAI_API_KEY_SAVED: 'openai_api_key_saved',
  PASSWORD_SETUP_COMPLETED: 'password_setup_completed',
  PLAN_CHECKOUT_STARTED: 'plan_checkout_started',
  PLAN_PURCHASE_FAILED: 'plan_purchase_failed',
  PRIVATE_NOTE_AUTO_SAVED: 'private_note_auto_saved',
  PRIVATE_NOTES_TOGGLED: 'private_notes_toggled',
  REPLY_BUTTON_CLICKED: 'reply_button_clicked',
  REPLY_DRAFT_GENERATED: 'reply_draft_generated',
  REPLY_SCHEDULED: 'reply_scheduled',
  REPLY_SENT: 'reply_sent',
  SCHEDULING_DRAFT_REPLY_CLICKED: 'scheduling_draft_reply_clicked',
  SCHEDULING_LINK_COPIED: 'scheduling_link_copied',
  SEARCH_BACK_TO_INBOX_CLICKED: 'search_back_to_inbox_clicked',
  SEARCH_HELP_CLICKED: 'search_help_clicked',
  SEARCH_PERFORMED: 'search_performed',
  SEARCH_RESULT_CLICKED: 'search_result_clicked',
  SEARCH_SLOW: 'search_slow',
  SEARCH_VIEWED: 'search_viewed',
  SENDER_BLOCKED: 'sender_blocked',
  SENDER_UNBLOCKED: 'sender_unblocked',
  SETTINGS_VIEWED: 'settings_viewed',
  SIDEBAR_COLLAPSE_CLICKED: 'sidebar_collapse_clicked',
  SIDEBAR_EXPAND_CLICKED: 'sidebar_expand_clicked',
  SIDEBAR_FOCUSBEAR_LINK_CLICKED: 'sidebar_focusbear_link_clicked',
  SIDEBAR_LOGO_CLICKED: 'sidebar_logo_clicked',
  SIDEBAR_LOGOUT_CLICKED: 'sidebar_logout_clicked',
  TONE_CHECK_DISMISSED: 'tone_check_dismissed',
  TONE_CHECK_DISPUTE_FORM_OPENED: 'tone_check_dispute_form_opened',
  TONE_CHECK_DISPUTE_SUBMITTED: 'tone_check_dispute_submitted',
  TONE_CHECK_REVISED_TEXT_USED: 'tone_check_revised_text_used',
  TONE_CHECK_SCHEDULE_FOR_MORNING_CLICKED: 'tone_check_schedule_for_morning_clicked',
  TONE_CHECK_SCHEDULE_FOR_MORNING_COMPOSE: 'tone_check_schedule_for_morning_compose',
  TONE_CHECK_DISPUTE_AUTO_SEND_TRIGGERED: 'tone_check_dispute_auto_send_triggered',
  TONE_CHECK_DISPUTE_AUTO_SEND_CANCELLED: 'tone_check_dispute_auto_send_cancelled',
  TONE_CHECK_SEND_ANYWAY: 'tone_check_send_anyway',
  TONE_RULE_ADDED: 'tone_rule_added',
  TONE_RULE_EDITED: 'tone_rule_edited',
  TONE_RULE_REMOVED: 'tone_rule_removed',
  TRIAGE_SUGGESTION_ACCEPTED: 'triage_suggestion_accepted',
  TRIAGE_SUGGESTION_ARCHIVE_ACCEPTED: 'triage_suggestion_archive_accepted',
  USER_LOGGED_IN: 'user_logged_in',
  USER_LOGGED_OUT: 'user_logged_out',
  USER_REGISTERED: 'user_registered',
  LANDING_SIGN_UP_CLICKED: 'landing-sign-up-clicked',
  WAIT_LIST_BUTTON_CLICKED: 'wait-list-button-clicked',
  WAIT_LIST_EMAIL_ENTERED: 'wait-list-email-entered',
  WAIT_LIST_EMAIL_PLATFORM_SELECTED: 'wait-list-email-platform-selected',
  WAIT_LIST_NAME_ENTERED: 'wait-list-name-entered',
  WAIT_LIST_REASON_ENTERED: 'wait-list-reason-entered',
  WAIT_LIST_SUBMITTED: 'wait-list-submitted',
  SIDEBAR_COMPOSE_CLICKED: 'sidebar_compose_clicked',
  SIDEBAR_INBOX_CLICKED: 'sidebar_inbox_clicked',
  SIDEBAR_SEARCH_CLICKED: 'sidebar_search_clicked',
  SIDEBAR_CONTACTS_CLICKED: 'sidebar_contacts_clicked',
  SIDEBAR_DEALS_CLICKED: 'sidebar_deals_clicked',
  SIDEBAR_STATS_CLICKED: 'sidebar_stats_clicked',
  SIDEBAR_SETTINGS_CLICKED: 'sidebar_settings_clicked',
  SIDEBAR_ADMIN_CLICKED: 'sidebar_admin_clicked',
  SIDEBAR_HELP_CLICKED: 'sidebar_help_clicked',
  SIDEBAR_SCHEDULED_CLICKED: 'sidebar_scheduled_clicked',
  CALENDAR_INVITE_ACCEPT_CLICKED: 'calendar_invite_accept_clicked',
  CALENDAR_INVITE_DECLINE_CLICKED: 'calendar_invite_decline_clicked',
} as const;
